import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

let testimonialsSwiperWr = document.querySelectorAll('.testimonials-swiper-wr');
testimonialsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let paginationEl = el.querySelector('.swiper-pagination');

    if (!swiperEl) return;

    let swiperConfig = {
      modules: [Navigation, Pagination, Autoplay],
      observer: true,
      observeParents: true,
      slidesPerView: 1,
      spaceBetween: 14,
      centeredSlides: true,
      loop: true,
      loopedSlides: 10,
      loopAdditionalSlides: 4,
      speed: 400,
      threshold: 10,
      preventInteractionOnTransition: true,
      watchSlidesProgress: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 1033,
      },
      breakpoints: {
        641: {
          slidesPerView: 1.6,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 2.3,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },
      on: {
        setTranslate(swiper) {
          swiper.slides.forEach((slide) => {
            const p = slide.progress;
            const translateY = p * p * 25;
            const rotate = -p * 4;
            slide.style.setProperty('--slide-translate-y', `${translateY}px`);
            slide.style.setProperty('--slide-rotate', `${rotate}deg`);
          });
        },
        setTransition(swiper, duration) {
          swiper.slides.forEach((slide) => {
            slide.style.transition = `transform ${duration}ms ease`;
          });
        },
        transitionEnd(swiper) {
          swiper.slides.forEach((slide) => {
            slide.style.transition = '';
          });
        },
      },
    };

    if (nextEl && prevEl) {
      swiperConfig.navigation = { nextEl, prevEl };
    }

    if (paginationEl) {
      swiperConfig.pagination = { el: paginationEl, clickable: true };
    }

    let swiper = new Swiper(swiperEl, swiperConfig);
    swiperObserver(swiper);
  }
});
